import { Link, useLocation, useNavigate } from "react-router-dom";
import { StyledLink, StyledProjectNavigation } from "./ProjectsNavigation.styles"
import { useSelector } from "react-redux";

const ProjectsNavigation = () => {
    const location = useLocation();
    return (
        <StyledProjectNavigation>
            <StyledLink to={`/projects/pitches`} isActive={location.pathname.includes("/pitches")}><p>Pitches</p></StyledLink>
            <StyledLink to={`/projects/ongoing`} isActive={location.pathname.includes("/ongoing")}><p>Ongoing</p></StyledLink>
            <StyledLink to={`/projects/completed`} isActive={location.pathname.includes("/completed")}><p>Completed</p></StyledLink>
        </StyledProjectNavigation>
    )
}

export default ProjectsNavigation;